import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getEmployeeDetailsReport = async ({
  companyCode,
  locationCode,
  departmentCode = 0,
  employeeType = "",
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  if (companyCode && locationCode) {
    let url = isAllCompanies
      ? `${Api_EndPoints.AllCompanies_EmployeeReports}`
      : `${Api_EndPoints.EmployeeReportList}`;

    let queryString = `?CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;

    if (departmentCode !== 0) {
      queryString += `&DepartmentCode=${departmentCode}`;
    }

    if (employeeType !== "") {
      queryString += `&EmployeeType=${employeeType}`;
    }

    if (isAllCompanies && userId !== 0) {
      queryString += `&UserId=${userId}`;
    }

    const { data } = await http_payroll.get(`${url}${queryString}`);
    return data;
  }

  return [];
};

export const useGetEmployeeDetailsReportQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_EmployeeReports
        : Api_EndPoints.EmployeeReportList,
      input,
    ],
    queryFn: () => getEmployeeDetailsReport(input),
    refetchOnWindowFocus: false,
  });
};
